import { render } from "./PreviewFile.vue?vue&type=template&id=1854b620"
import script from "./PreviewFile.vue?vue&type=script&lang=js"
export * from "./PreviewFile.vue?vue&type=script&lang=js"

import "./PreviewFile.vue?vue&type=style&index=0&id=1854b620&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__